// extracted by mini-css-extract-plugin
export var accountContent = "stylizations-module--account-content--8te94";
export var bar = "stylizations-module--bar--OSUyg";
export var button = "stylizations-module--button--gpb9g";
export var buttonGenerate = "stylizations-module--button-generate--cffh3";
export var container = "stylizations-module--container--KzVIt";
export var error = "stylizations-module--error--xKcQ-";
export var icon = "stylizations-module--icon--nEZAD";
export var info = "stylizations-module--info--GEa9M";
export var list = "stylizations-module--list--lMncQ";
export var lookCard = "stylizations-module--look-card--NdMTs";
export var lookDate = "stylizations-module--look-date--TQ+n9";
export var lookMeta = "stylizations-module--look-meta--rkTu7";
export var lookTag = "stylizations-module--look-tag--OrEqd";
export var lookThumb = "stylizations-module--look-thumb--LOw9o";
export var lookThumbGrid = "stylizations-module--look-thumb-grid--it-vU";
export var lookThumbImg = "stylizations-module--look-thumb-img--TORg9";
export var lookThumbPlaceholder = "stylizations-module--look-thumb-placeholder--mK+lS";
export var looksGrid = "stylizations-module--looks-grid--US6g+";
export var section = "stylizations-module--section--41e4B";
export var sectionHeader = "stylizations-module--section-header--KJ-Tt";
export var sectionHeaderButton = "stylizations-module--section-header-button--an3q1";
export var sectionHeaderDescription = "stylizations-module--section-header-description--mBl5Y";
export var sectionHeaderTitle = "stylizations-module--section-header-title--lJMC0";
export var stylizationItem = "stylizations-module--stylization-item--sKIkL";
export var title = "stylizations-module--title--NNVhn";
export var tryOnButton = "stylizations-module--try-on-button--bCCbe";
export var tryOnHeading = "stylizations-module--try-on-heading--1ZUX0";
export var tryOnNotice = "stylizations-module--try-on-notice--rLuYx";
export var tryOnPanel = "stylizations-module--try-on-panel--CxUuU";
export var tryOnProduct = "stylizations-module--try-on-product--BrlKe";
export var tryOnProductImage = "stylizations-module--try-on-product-image--Bg10E";
export var tryOnProductName = "stylizations-module--try-on-product-name--d80Zx";
export var tryOnProducts = "stylizations-module--try-on-products--HBvMC";
export var tryOnResult = "stylizations-module--try-on-result--+ICz0";
export var tryOnText = "stylizations-module--try-on-text--aaONV";